export default "__VITE_ASSET__07da62d5__"